import classNames from 'classnames';
import { FlexContainer, ContentBlock, Txt } from 'components';
import { formatCurrency } from 'helpers/formatNumber';
import styles from './ViewPaymentsList.module.scss';

/**
 * ViewPaymentsList
 *
 * @return {JSX.Element}
 */
const ViewPaymentsList = ({ className, data = [] }) => {
  return (
    <FlexContainer
      className={classNames(
        styles.ViewPaymentsList,
        className,
        ViewPaymentsList.displayName
      )}
      column
      gapHalf
    >
      {data.map((i) => (
        <ContentBlock key={i.paymentUid} column gapQuad>
          <Txt x>£{formatCurrency(i.amountPaid)}</Txt>
          <Txt>{i.paymentFromName}</Txt>
        </ContentBlock>
      ))}
    </FlexContainer>
  );
};

ViewPaymentsList.displayName = 'ViewPaymentsList';

export default ViewPaymentsList;
